const pageNameKey = "sse";

export const sseEn = {
  [pageNameKey]: {
    serviceSupportErrorText:
      "The connection to the service-support server is currently unstable, we might not be able to update the status of your tickets.",
    machineEventsErrorText:
      "The connection to the service-machine-events server is currently unstable, we might not be able to receive or update machine events.",
    vpnManagerErrorText:
      "The connection to the service-vpn-manager server is currently unstable, VPN connectivity or status updates may be affected.",
    reconnectingActionsUnavailableTooltip:
      "Reconnecting… actions are temporarily unavailable",
  },
};

export const ssePtBr = {
  [pageNameKey]: {
    serviceSupportErrorText:
      "A conexão com o servidor de suporte de serviço está instável no momento.",
    machineEventsErrorText:
      "A conexão com o servidor service-machine-events está instável no momento. Talvez não seja possível receber ou atualizar eventos da máquina.",
    vpnManagerErrorText:
      "A conexão com o servidor service-vpn-manager está instável no momento.",
    reconnectingActionsUnavailableTooltip:
      "Reconectando… as ações estão temporariamente indisponíveis",
  },
};

export const sseDe = {
  [pageNameKey]: {
    serviceSupportErrorText:
      "Die Verbindung zum service-support-Server ist derzeit instabil, daher können wir den Status Ihrer Tickets möglicherweise nicht aktualisieren.",
    machineEventsErrorText:
      "Die Verbindung zum service-machine-events-Server ist derzeit instabil, daher können wir Maschinenereignisse möglicherweise nicht empfangen oder aktualisieren.",
    vpnManagerErrorText:
      "Die Verbindung zum service-vpn-manager-Server ist derzeit instabil, VPN-Verbindungen oder Statusaktualisierungen können beeinträchtigt sein.",
    reconnectingActionsUnavailableTooltip:
      "Erneute Verbindung… Aktionen sind vorübergehend nicht verfügbar",
  },
};

export const sseZhHans = {
  [pageNameKey]: {
    serviceSupportErrorText:
      "与 service-support 服务器的连接目前不稳定，我们可能无法更新您的工单状态。",
    machineEventsErrorText:
      "与 service-machine-events 服务器的连接目前不稳定，我们可能无法接收或更新机器事件。",
    vpnManagerErrorText:
      "与 service-vpn-manager 服务器的连接目前不稳定，VPN 连接或状态更新可能会受到影响。",
    reconnectingActionsUnavailableTooltip: "正在重新连接…操作暂时不可用",
  },
};

export const sseIt = {
  [pageNameKey]: {
    serviceSupportErrorText:
      "La connessione al server di supporto è attualmente instabile, potremmo non essere in grado di aggiornare lo stato dei vostri ticket.",
    machineEventsErrorText:
      "La connessione al server service-machine-events è attualmente instabile, potrebbe non essere possibile ricevere o aggiornare gli eventi della macchina.",
    vpnManagerErrorText:
      "La connessione al server service-vpn-manager al momento è instabile, la connettività VPN o gli aggiornamenti dello stato potrebbero essere influenzati.",
    reconnectingActionsUnavailableTooltip:
      "Riconnessione in corso… le azioni sono temporaneamente non disponibili",
  },
};

export const sseEs = {
  [pageNameKey]: {
    serviceSupportErrorText:
      "La conexión con el servidor de soporte del servicio es inestable en este momento; es posible que no podamos actualizar el estado de tus tickets.",
    machineEventsErrorText:
      "La conexión con el servidor service-machine-events es actualmente inestable; es posible que no podamos recibir ni actualizar los eventos de la máquina.",
    vpnManagerErrorText:
      "La conexión con el servidor service-vpn-manager es actualmente inestable; la conectividad VPN o las actualizaciones de estado pueden verse afectadas.",
    reconnectingActionsUnavailableTooltip:
      "Reconectando… las acciones están temporalmente no disponibles",
  },
};

export const sseNl = {
  [pageNameKey]: {
    machineEventsErrorText:
      "De verbinding met de service-machine-events-server is momenteel onstabiel, mogelijk kunnen we machinegebeurtenissen niet ontvangen of bewerken.",
    serviceSupportErrorText:
      "De verbinding met de service-supportserver is momenteel instabiel. Mogelijk kunnen we de status van uw tickets niet bijwerken.",
    vpnManagerErrorText:
      "De verbinding met de service-vpn-manager-server is momenteel onstabiel, de VPN-connectiviteit of statusupdates kunnen worden beïnvloed.",
    reconnectingActionsUnavailableTooltip:
      "Opnieuw verbinden… acties zijn tijdelijk niet beschikbaar",
  },
};

export const sseTr = {
  [pageNameKey]: {
    machineEventsErrorText:
      "Hizmet-makine-olayları sunucusuyla bağlantı şu anda kararsız; makine olaylarını alamayabilir veya güncelleyemeyebiliriz.",
    serviceSupportErrorText:
      "Hizmet-destek sunucusuyla bağlantı şu anda istikrarsız, destek bildirimlerinizin durumunu güncelleyemeyebiliriz.",
    vpnManagerErrorText:
      "Service-vpn-manager sunucusuna olan bağlantı şu anda kararsız, VPN bağlantısı veya durum güncellemeleri etkilenebilir.",
    reconnectingActionsUnavailableTooltip:
      "Yeniden bağlanılıyor… işlemler geçici olarak kullanılamıyor",
  },
};
